import React from 'react';

const IrelandImportH1PrefixIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none" {...props}>
            <path d="M7 9H5.549V4.93707H1.45707V9H0V0H1.45707V3.68126H5.549V0H7V9Z" fill="var(--polar-green-6)" />
            <path
                d="M10.1547 9.00016H9.34751V5.78186C9.34751 5.6747 9.34865 5.56754 9.35093 5.46037C9.35321 5.35321 9.35549 5.24833 9.35777 5.14573C9.36233 5.04312 9.36803 4.94508 9.37487 4.8516C9.32699 4.90404 9.26771 4.96104 9.19703 5.0226C9.12863 5.08417 9.05566 5.14801 8.97814 5.21413L8.40357 5.67242L8 5.16283L9.48431 4H10.1547V9.00016Z"
                fill="var(--polar-green-6)"
            />
        </svg>
    );
};

export default IrelandImportH1PrefixIcon;
